// @ts-nocheck: converted from JS

import Dashboard from '@/components/Dashboard';

export default Dashboard;
